import React, { useState } from 'react'
import BulkList from './bulks_list'
import PackageCart from './svg/package_cart'

export default function MainStatuses(props) {
    const ticket_types = props.ticket_types
    const [currentBulk, setCurrentBulk] = useState(null)
    const getColor = (index) => {
        if (index === 0) {
            return "#2160C6"
        } else if (index === 1) {
            return "#12418D"
        } else {
            return "#2F3F58"
        }
    }
    const getIconColor = (index) => {
        if (index === 0) {
            return "#FFFFFF"
        } else if (index === 1) {
            return "#84C0FF"
        } else {
            return "#00C408"
        }
    }
    const getTextColor = (index) => {
        if (index === 0) {
            return "#95BDFF"
        } else if (index === 1) {
            return "#95BDFF"
        } else {
            return "#95BDFF"
        }
    }
    return (<div className="shipment_main_statuses">
        {ticket_types.map((type, index) => <div key={index}
            className='status_normal_employee_parent'>
            <div className='status_normal_employee' style={{ backgroundColor: getColor(index) }} >
                <PackageCart color1={getIconColor(index)} color2={getIconColor(index)} />
                <div className='status_normal_employee_type' style={{ color: getTextColor(index) }} >
                    {type.name} {" "}
                    {type.tickets_count}
                </div>
            </div>
            <BulkList
                currentBulk={currentBulk}
                setCurrentBulk={(e) => setCurrentBulk(e)}
                data={type.tickets}
                chat={type}
                ticket_status_id={type.id}
                expanded={false}
                getPage={(e) => props.getPage(e)}
                total_count={type.tickets_count}
                ticketColor={getColor(index)}
                status={type.name}
                editTicket={props.editTicket}
                finishEditTicket={props.finishEditTicket}
                index={index}
                color1={getIconColor(index)}
                color2={getIconColor(index)}
            // mainStatuses={mainStatuses}
            // selectedFilter={fakeFilterSelected[index]}
            />
        </div>)}
    </div>)

}